import "./AdminPanelInfo.css";

function AdminPanelInfo () {


    return (
        <div className="container">
            <div className="row adminInfoContainer">
                <h5>Welcome to the admin panel</h5>
                <p>Use the navigation panel to go to the user management, order details, statistics and products management</p>
            </div>
        </div>
    )
}


export default AdminPanelInfo;